const capitalizeFirstChar = ([first, ...rest]: string) =>
  (first ?? '').toLocaleUpperCase() + rest.join('');

export default capitalizeFirstChar;
